import styled from 'styled-components';

export const StyledHtmlRenderer = styled.div`
  /* Basic text formatting */
  b,
  strong {
    font-weight: 600;
  }

  i,
  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  s {
    text-decoration: line-through;
  }

  mark {
    background-color: #ffeb3b;
    padding: 0.1em 0.2em;
  }

  small {
    font-size: 0.875em;
  }

  sup {
    vertical-align: super;
    font-size: 0.75em;
  }

  sub {
    vertical-align: sub;
    font-size: 0.75em;
  }

  /* Links */
  a {
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #1565c0;
    }

    &:visited {
      color: #7b1fa2;
    }
  }

  /* Paragraphs */
  p {
    margin: 0.5em 0;
    line-height: 1.5;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* Headings */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0.75em 0 0.5em;
    line-height: 1.3;
    font-weight: 600;

    &:first-child {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.25em;
  }

  h4 {
    font-size: 1.1em;
  }

  h5 {
    font-size: 1em;
  }

  h6 {
    font-size: 0.9em;
  }

  /* Lists */
  ul,
  ol {
    margin: 0.5em 0;
    padding-left: 1.5em;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin: 0.25em 0;
    line-height: 1.5;
  }

  /* Code */
  code {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 3px;
    padding: 0.1em 0.3em;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.9em;
  }

  pre {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 0.75em;
    margin: 0.5em 0;
    overflow-x: auto;
    line-height: 1.4;

    code {
      background: none;
      border: none;
      padding: 0;
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* Blockquote */
  blockquote {
    margin: 0.5em 0;
    padding: 0.5em 1em;
    border-left: 4px solid #e0e0e0;
    background-color: #f9f9f9;
    font-style: italic;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* Divs and spans */
  div {
    display: block;
  }

  span {
    display: inline;
  }

  /* Line breaks */
  br {
    display: block;
    margin: 0.25em 0;
    content: '';
  }
`;
